import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';

/** Bids the user dismissed from the banner, kept per browser. */
export const useIgnoredBids = () => {
  const [ignoredBids, setIgnoredBids] = useLocalStorage(
    'myBidsBannerIgnoredBids',
    []
  );

  return {
    ignoredBids,
    ignoreBid: (id: string) => setIgnoredBids([...ignoredBids, id]),
  };
};
